'use strict';

module.exports = require('./react-lite-yt-embed.cjs.production.min.js');